import { useEffect } from "react";

function AdRight() {
    useEffect(() => {
        const timer = setTimeout(() => {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                console.error("AdSense error:", e);
            }
        }, 500); // 렌더링 후 약간의 지연 (0.5초)
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="ad-wrapper">
            <style>
                {`
            .ad-wrapper {
                width: 100%;
                min-width: 300px;
                max-width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 20px 0;
                z-index: 0;
            }

            @media (max-width: 1300px) { /* 400px 미만일 때 광고 영역 전체 삭제 */
                .ad-wrapper {
                    display: none;
                }
            }
            
            @media (max-height: 600px) { /* 400px 미만일 때 광고 영역 전체 삭제 */
                .ad-wrapper {
                    display: none;
                }
            }        
        `}
            </style>
            <ins
                className="adsbygoogle"
                style={{
                    display: "block",
                    width: "100%",
                    width: "100%",
                    minWidth: "300px",
                    height: "400px",
                    height: "400px",
                }}
                data-ad-client="ca-pub-1492721454822806"
                data-ad-slot="5138465000"
                data-ad-format="auto"
                data-full-width-responsive="true"
            ></ins>
        </div>
    );
}

export default AdRight;